export default {
  1: 'black', // Not Started
  2: '', // Active
  3: 'grey', // Archived
}
